import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Row } from 'antd'

import { HraBenefitOverviewResponse } from 'core/application/benefit/getHraBenefitOverview'

import { formatMoney, formatMoneyIntegers } from 'common/moneyFormatter'

import { AllowanceCard, SignType } from '../card'

const MonthlyAllowance: React.FC<HraBenefitOverviewResponse> = (props) => {
  const { t: translate } = useTranslation()
  const MonthlyAllowanceCardInfos: AllowanceCard[] = [
    {
      id: 0,
      icon: 'ballot-check',
      description: translate('admin-dashboard.home.allowance.total-monthly'),
      amount: 0,
      signType: SignType.Dollar,
    },
    {
      id: 1,
      icon: 'usd-circle',
      description: translate('admin-dashboard.home.allowance.total-monthly-reimbursed'),
      amount: 0,
      signType: SignType.Dollar,
    },
    {
      id: 2,
      icon: 'coins',
      description: translate('admin-dashboard.home.allowance.total-monthly-remaining'),
      amount: 0,
      signType: SignType.Dollar,
    },
    {
      id: 3,
      icon: 'tasks',
      description: translate('admin-dashboard.home.allowance.reimbursements'),
      amount: 0,
      signType: SignType.Dollar,
    },
  ]

  return (
    <Row gutter={16}>
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <AllowanceCard {...MonthlyAllowanceCardInfos[0]} amount={formatMoneyIntegers(props.totalAllowance ?? 0)} />
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <AllowanceCard {...MonthlyAllowanceCardInfos[1]} amount={formatMoneyIntegers(props.totalReimbursed ?? 0)} />
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <AllowanceCard
          {...MonthlyAllowanceCardInfos[2]}
          amount={formatMoneyIntegers(props.totalAllowanceRemaining ?? 0)}
        />
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <AllowanceCard {...MonthlyAllowanceCardInfos[3]} amount={formatMoneyIntegers(props.reimbursementsDue ?? 0)} />
      </Col>
    </Row>
  )
}

export default MonthlyAllowance
